import actionTypes from "../actionTypes";
import { buildMessage } from "../helper/call.helper";
import messageAction from "./message.action";
import callAction from "./call.action";
import globalAction from "./global.action";
import { globalStateSelector } from "../selector";
import messageHelper from "../helper/message.helper";

export default {
  setCallInfo: (data, userId) => (dispatch) => {
    dispatch({
      type: actionTypes.CALL_INFO,
      payload: data,
      userId: userId,
    });
  },
  setCallList: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.CALL_List,
      payload: data,
    });
  },
  setTranscription: (data) => (dispatch) => {
    console.log("[call.action]", data);
    dispatch({
      type: actionTypes.TRANSCRIPTION_SET,
      payload: data,
    });
  },
  updateTranscription: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.TRANSCRIPTION_UPDATE,
      payload: data,
    });
  },
  setSummary: (data) => (dispatch) => {
    console.log("[call.action.summary]", data);
    dispatch({
      type: actionTypes.SUMMARY_SET,
      payload: data,
    });
  },
  clearSummary: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.SUMMARY_CLEAR,
      payload: data,
    });
  },
  setSummaryLoading: (data) => (dispatch) => {
    console.log("[call.action.summaryLoading]", data);
    dispatch({
      type: actionTypes.SUMMARY_LOADING_SET,
      payload: data,
    });
  },
  setAgentAssist: (data) => (dispatch) => {
    console.log("data[action]", data);
    dispatch({
      type: actionTypes.AGENT_ASSIST,
      payload: data,
    });
  },
  clearTranscription: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.CLEAR_TRANSCRIPTION,
      payload: data,
    });
  },
  clearAgentAssist: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.CLEAR_AGENT_ASSIST,
      payload: data,
    });
  },
  clearChecklist: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.CLEAR_CHECKLIST,
      payload: data,
    })
  },
  updateTranslateCall: (id, translateText) => (dispatch) => {
    console.log("id, translateText", id, translateText);
    dispatch({
      type: actionTypes.UPDATE_TRANSLATE_CALL,
      payload: { id, translateText },
    });
  },
  setCallChecklist: (data) => (dispatch) => {
    console.log("[call.action.callChecklist]", data);
    dispatch({
      type: actionTypes.CALL_CHECKLIST,
      payload: data,
    });
  },
  process: (type, data) => (dispatch, getState) => {
    console.log(`[Call-Action] Started `, type, data);

    if (type === "AddTAGToCall") {
      let call = {
        pattern: "AddTAGToCall",
        subtype: "AddTAGToCall",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callHangup") {
      let call = {
        pattern: "hangUp",
        subtype: "hangUp",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callMute") {
      let call = {
        pattern: "callMute",
        subtype: "callMute",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callUnMute") {
      let call = {
        pattern: "callUnMute",
        subtype: "callUnMute",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callTransferStart") {
      let call = {
        pattern: "callTransferStart",
        subtype: "callTransferStart",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callTransferCancel") {
      let call = {
        pattern: "callTransferCancel",
        subtype: "callTransferCancel",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callTransferAgent") {
      let call = {
        pattern: "callTransferAgent",
        subtype: "callTransferAgent",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callTransferTalk") {
      let call = {
        pattern: "callTransferTalk",
        subtype: "callTransferTalk",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callTransferFlow") {
      let call = {
        pattern: "callTransferFlow",
        subtype: "callTransferFlow",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callTransferAgentMerge") {
      let call = {
        pattern: "callTransferAgentMerge",
        subtype: "callTransferAgentMerge",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callTransferAgentCancel") {
      let call = {
        pattern: "callTransferAgentCancel",
        subtype: "callTransferAgentCancel",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callHold") {
      let call = {
        pattern: "callHold",
        subtype: "callHold",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callUnHold") {
      let call = {
        pattern: "callUnHold",
        subtype: "callUnHold",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "dtmfSend") {
      let call = {
        pattern: "dtmfSend",
        subtype: "dtmfSend",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "monitorCall") {
      console.log("monitorCall data ", data);
      let call = {
        pattern: "monitorCall",
        subtype: "monitorCall",
        type: "callHandler",
        body: data,
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      console.log("monitorCall call ", call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "monitorTranscript") {
      console.log("monitorTranscript data ", data);
      let call = {
        pattern: "monitorTranscript",
        subtype: "monitorTranscript",
        type: "callHandler",
        body: data,
        replayTo: "notification-to-ui",
        status: data.status,
      };
      call = buildMessage(call);
      console.log("monitorTranscript call ", call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "monitorCallHangup") {
      console.log("monitorCallHangup data ", data);
      let call = {
        pattern: "voice:hangup",
        subtype: "voice:hangup",
        type: "callHandler",
        body: data,
        replayTo: "notification-to-ui",
        status: data.status,
      };
      call = buildMessage(call);
      console.log("monitorCallHangup call ", call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "monitorCallInboundBlock") {
      console.log("monitorCallInboundBlock data ", data);
      let call = {
        pattern: "voice:inbound:block",
        subtype: "voice:inbound:block",
        type: "callHandler",
        body: data,
        replayTo: "notification-to-ui",
        status: data.status,
      };
      call = buildMessage(call);
      console.log("monitorCallInboundBlock call ", call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callAndPark") {
      console.log("callAndPark data ", data);
      let call = {
        pattern: "callAndPark",
        subtype: "callAndPark",
        type: "callHandler",
        body: data,
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      console.log("flowCall call ", call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "callInitiate") {
      const state = getState();
      let selectedTeam = globalStateSelector.getSelectedTeam(state);
      let info = data.info || {};
      let callingMode = info.callingMode || "";
      if (data.teamId) {
        selectedTeam = {
          _id: data.teamId,
          name: data.teamName,
        };
      }
      let call = {
        pattern: "callAndConnect",
        subtype: "callAndConnect",
        type: "callHandler",
        body: {
          team: selectedTeam,
          call: {
            type: "phone",
            number: data.phoneNumber,
          },
          ...info,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      if (callingMode != "preview") {
        dispatch(callAction.setCallCustomerNumber({ data: data.phoneNumber }));
        dispatch(callAction.setCallCustomerName({ data: "No Name" }));
      }
      // dispatch(callAction.setCallStartTime(""));
      // dispatch(callAction.setCallCurrentTime(""));
      // dispatch(messageAction.emitSocketMessage('message-processor', call));
      if (selectedTeam && selectedTeam._id) {
        dispatch(
          messageAction.configProcessor(`tagList`, { teamId: selectedTeam._id })
        );
      }

      if (selectedTeam && selectedTeam._id) {
        dispatch(
          globalAction.dynamicUpdate({ data: { key: "comments", value: [] } })
        );
        dispatch(
          messageAction.configProcessor(`customerComments`, {
            teamId: selectedTeam._id,
            mobileNumber: data.phoneNumber,
            limit: 10,
            page_no: 1,
          })
        );
        dispatch(
          globalAction.dynamicUpdate({
            data: {
              key: "callTeam",
              value: { id: selectedTeam._id, name: selectedTeam.name || "" },
            },
          })
        );
        if (callingMode != "preview") {
          dispatch(
            globalAction.dynamicUpdate({ data: { key: "custInfo", value: {} } })
          );
          dispatch(
            messageAction.configProcessor(`contactList`, {
              teamId: selectedTeam._id,
              mobileNumber: data.phoneNumber,
            })
          );
          try {
            messageHelper.iframeEvent("softphoneCallInvited", {
              from: {
                "number": data.phoneNumber,
              }
            });
          } catch (error) {
            console.log(`iframeEvent error softphoneCallInvited`, error);
          }
        }
      }
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "bridgeCall") {
      let call = {
        pattern: "bridgeCall",
        subtype: "bridgeCall",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else if (type === "bridgeHungup") {
      let call = {
        pattern: "bridgeHungup",
        subtype: "bridgeHungup",
        type: "callHandler",
        body: {
          ...data,
        },
        replayTo: "notification-to-ui",
      };
      call = buildMessage(call);
      dispatch(messageAction.emitSocketMessage("message-processor", call));
    } else {
      console.error(`[Call-Action] Type Not Define `, type);
    }
  },
  setCallCustomerNumber: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.CALL_CUSTOMER_NUMBER,
      payload: data,
    });
  },
  setCallCustomerName: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.CALL_CUSTOMER_NAME,
      payload: data,
    });
  },
  setCallStartTime: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.CALL_START_TIME,
      payload: data,
    });
  },
  setCallCurrentTime: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.CALL_CURRENT_TIME,
      payload: data,
    });
  },
};



// WEBPACK FOOTER //
// src/store/action/call.action.js